import Component from '../core/Component'

export const STATE = {
    COLLAPSED: 'is-collapsed',
    RESPONDING: 'is-responding'
}

export default class Discussion extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            buttonExpand: null,
            form: null,
            replyButtons: []
        }
    }

    prepare() {
        if (this.ref.buttonExpand) {
            this.ref.buttonExpand.addEventListener('click', ::this.handleClick)
        }
        this.ref.replyButtons.forEach(element => element.addEventListener('click', ::this.handleReplyClick))
    }

    handleClick(event) {
        event.preventDefault()
        this.element.classList.remove(STATE.COLLAPSED)
    }

    handleReplyClick(event) {
        event.preventDefault()

        const post = event.target.closest('.discussion-Post')

        post.classList.add(STATE.RESPONDING)

        const form = this.ref.form.cloneNode(true)
        form.addEventListener('reset', ::this.handleReplyCancel)
        form.addEventListener('submit', ::this.handleReplySubmit)
        event.target.parentNode.appendChild(form)
        form.querySelector('[data-ref="replyTo"]').value = event.target.dataset.id
    }

    handleReplyCancel(event) {
        const post = event.target.closest('.discussion-Post')
        post.classList.remove(STATE.RESPONDING)
        event.target.parentNode.removeChild(event.target)
    }

    handleReplySubmit(event) {
        event.preventDefault()
        $(event.target).netteAjax(event)
    }

}